module.exports = __webpack_public_path__ + "static/media/KVKK.6972764e.docx";